<template>
  <div class="after-sale">
    <div class="switch-menu">
      <el-radio-group
        class="menu-name"
        v-for="(item, index) in menuList"
        :key="index"
        v-model="selectedTab"
        @change="toUrl(item.url)"
      >
        <el-radio-button :label="item.name"></el-radio-button>
      </el-radio-group>
    </div>

    <div class="search-container">
      <div class="statistics">
        <div
          v-for="(item,index) in statisticsList"
          :key="index"
          class="item-statistics border-right"
          :class="(index+1) > 3? 'border-top':''"
        >
          <img class="statistics-img" :src="item.img" alt>
          <div class="statistics-info">
            <div class="sub-title">
              <span>{{item.title}}</span>
              <img 
                v-if="item.title === '未揽收订单数'" 
                class="look-img" 
                src="../../../../../assets/images/production-data/look.png"
                @click="openUncollectedOrderNums"
              >
            </div>
            <p v-if="!item.isFlag" class="sub-content">{{item.content}}</p>
            <div v-else class="express-container">
              <p v-if="item.list.length === 0">—</p>
              <p class="express-content" v-for="(v, idx) in item.list" :key="idx">{{`${v.expressName}: ${v.orderNum}`}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="search">
        <div class="search-left">
          <el-select
            v-model="warehouseId"
            clearable
            class="gray"
            placeholder="请选择仓库"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-date-picker
            class="gray marginRight"
            v-model="date"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            placeholder="选择日期">
          </el-date-picker>
          <el-button class="btn-white" @click="clearData">重置</el-button>
          <el-button class="btn-blue" @click="searchData">搜索</el-button>
        </div>
      </div>
    </div>
    
    <div class="production-list-container">
      <ul class="columns">
        <li class="long">项目详情</li>
        <li class="short">揽收订单数</li>
        <li class="short">揽收率</li>
        <li class="short">0-24H揽收单量</li>
        <li class="short">24H-48H揽收单量</li>
        <li class="short">48H以上揽收单量</li>
      </ul>
      <ul v-show="tableData.length" class="order-list">
        <li class="order" v-for="(item, index) in tableData" :key="index">
          <div class="time-ordernum">
            <span class="time">截单时间：{{item.createTime}}</span>
            <div class="finish-order-num">
              完成订单数：
              <span class="num">{{item.finishOrderNums}}</span>
            </div>
          </div>
          <div class="production-content">
            <div class="long">{{item.name}}</div>
            <div class="short">
              <p v-if="!item.collectOrderNum">—</p>
              <div v-else>
                <p class="details-nums">{{item.collectOrderNum.totalValue}}</p>
                <p class="details-expenses" v-for="(v, idx) in item.collectOrderNum.carrierCollectInfoList" :key="idx">{{`(${v.carrierKey}：${v.carrierValue})`}}</p>
              </div>
            </div>
            <div class="short">
              <p v-if="!item.yield">—</p>
              <div v-else>
                <p class="details-nums">{{item.yield.totalValue}}</p>
                <p class="details-expenses" v-for="(v, idx) in item.yield.carrierCollectInfoList" :key="idx">{{`(${v.carrierKey}：${v.carrierValue})`}}</p>
              </div>
            </div>
            <div class="short">
              <p v-if="!item.oneDaysWithin">—</p>
              <div v-else>
                <p class="details-nums">{{item.oneDaysWithin.totalValue}}</p>
                <p class="details-expenses" v-for="(v, idx) in item.oneDaysWithin.carrierCollectInfoList" :key="idx">{{`(${v.carrierKey}：${v.carrierValue})`}}</p>
              </div>
            </div>
            <div class="short">
              <p v-if="!item.twoDaysWithin">—</p>
              <div v-else>
                <div class="details-nums">
                  <span>{{item.twoDaysWithin.totalValue}}</span>
                  <img 
                    class="look-img" 
                    src="../../../../../assets/images/production-data/look.png"
                    @click="openTwoDaysWithinCollectedOrderNums(item.id)"
                  >
                </div>
                <p class="details-expenses" v-for="(v, idx) in item.twoDaysWithin.carrierCollectInfoList" :key="idx">{{`(${v.carrierKey}：${v.carrierValue})`}}</p>
              </div>
            </div>
            <div class="short">
              <p v-if="!item.twoDaysAway">—</p>
              <div v-else>
                <div class="details-nums">
                  <span>{{item.twoDaysAway.totalValue}}</span>
                  <img 
                    class="look-img" 
                    src="../../../../../assets/images/production-data/look.png"
                    @click="openTwoDaysAwayCollectedOrderNums(item.id)"
                  >
                </div>
                <p class="details-expenses" v-for="(v, idx) in item.twoDaysAway.carrierCollectInfoList" :key="idx">{{`(${v.carrierKey}：${v.carrierValue})`}}</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="tip" v-show="!tableData.length">暂无数据</div>
    </div>

    
    <!-- 未揽收订单数 -->
    <el-dialog
      title="未揽收订单数"
      top="15vh"
      :visible.sync="dialog"
      width="820px"
      :close-on-click-modal="false"
    >
      <div class="search-dialog">
        <div class="search-left">
          <el-select
            class="gray white w200"
            v-model="projectName"
            filterable
            clearable
            placeholder="请选择项目名称"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            class="gray white w200"
            v-model="expressId"
            filterable
            clearable
            placeholder="请选择承运商"
          >
            <el-option
              v-for="item in logisticsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button class="btn-blue" @click="searchUncollectedOrderNumsData">搜索</el-button>
        </div>
        <el-button class="btn-blue" @click="downLoadExcel">导出</el-button>
      </div>
      <div class="table">
        <el-table :data="uncollectedOrderNumsTableList" style="width: 100%;">
          <el-table-column
            v-for="(item, index) in uncollectedOrderNumsTableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            show-overflow-tooltip
            :min-width="item.width"
          ></el-table-column>
        </el-table>
        <div class="pagination">
          <pagination-tpl
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @queryChange="queryChange"
          ></pagination-tpl>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 揽收单量 -->
    <el-dialog
      :title="dialogTitle"
      top="15vh"
      :visible.sync="collectedOrderNumsDialog"
      width="820px"
      :close-on-click-modal="false"
    >
      <div class="search-dialog">
        <div class="search-left">
          <el-select
            v-model="expressType"
            filterable
            clearable
            class="gray"
            placeholder="请选择承运商"
          >
            <el-option
              v-for="item in logisticsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button class="btn-blue" @click="searchCollectedOrderNumsData">搜索</el-button>
        </div>
      </div>
      <div class="table">
        <el-table :data="collectedOrderNumsTableList" style="width: 100%;">
          <el-table-column
            v-for="(item, index) in collectedOrderNumsTableTitleList"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            show-overflow-tooltip
            :min-width="item.width"
          ></el-table-column>
        </el-table>
        <div class="pagination">
          <pagination-tpl
            :total="collectedTotal"
            :currentPage="collectedTotalCurrentPage"
            :pageSize="collectedTotalPageSize"
            @queryChange="collectedQueryChange"
          ></pagination-tpl>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-white" @click="closeCollectedOrderDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatTimeToDate, formaTimeToMinute } from "common/js/util";
import Expenses from "models/expenses";
const expenses = new Expenses();
import Logistics from "models/logistics";
const logistics = new Logistics();
import PersonnelPay from "models/personnel-pay";
const personnelPay = new PersonnelPay();
import AfterSale from "models/after-sale";
import PaginationTpl from "components/base/PaginationTpl";
export default {
  components: {
    PaginationTpl,
  },

  data() {
    return {
      selectedTab: '售后数据',
      menuList: [
        {name: '发货数据', url: '/home/production-data/shipment-data'},
        {name: '售后数据', url: '/home/production-data/after-sale'}
      ],
      date: formatTimeToDate(new Date().getTime() - 60*60*24*1000),
      warehouseId: '',
      warehouseList: [],
      statisticsList: [
        {isFlag: 0, title: '揽收订单数', content: 0, img: require('../../../../../assets/images/shipment-data/total-order-num.png')},
        {isFlag: 0, title: '完成订单数', content: 0, img: require('../../../../../assets/images/shipment-data/finish-order-num.png')},
        {isFlag: 0, title: '未揽收订单数', content: 0, img: require('../../../../../assets/images/shipment-data/incomplete-order-num.png')},
        {list: [],isFlag: 1, title: '24小时内揽收', content: 0, img: require('../../../../../assets/images/production-data/24hours.png')},
        {list: [],isFlag: 1, title: '24-48小时内揽收', content: 0, img: require('../../../../../assets/images/production-data/36hours.png')},
        {list: [],isFlag: 1, title: '48小时以上揽收', content: 0, img: require('../../../../../assets/images/production-data/48hours.png')},
      ],
      tableData: [],
      dialog: false,
      projectName: '',
      projectList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      uncollectedOrderNumsTableList: [],
      uncollectedOrderNumsTableTitleList: [
        {label: '项目名称', prop: 'projectName', width: ''},
        {label: '快递类型', prop: 'expressTypeName', width: ''},
        {label: '订单号', prop: 'orderCode', width: ''},
        {label: '运单号', prop: 'expenseCode', width: ''},
      ],
      dialogTitle: '24H-48H揽收单量',
      collectedOrderNumsDialog: false,
      /* 2:24H-48H揽收单量; 3:48H以上揽收单量  */
      type: 2,
      expressId: '',
      expressType: '',
      collectedProjectId: '',
      logisticsList: [],
      collectedTotal: 0,
      collectedTotalCurrentPage: 1,
      collectedTotalPageSize: 10,
      collectedOrderNumsTableList: [],
      collectedOrderNumsTableTitleList: [
        {label: '订单号', prop: 'orderCode', width: ''},
        {label: '运单号', prop: 'expenseCode', width: ''},
        {label: '付款时间', prop: 'paymentTime', width: '150'},
        {label: '接单时间', prop: 'orderTakingTime', width: '150'},
        {label: '完成时间', prop: 'finishTime', width: '150'},
        {label: '揽收时间', prop: 'collectedTime', width: '150'},
      ],
    }
  },

  async created() {
    await this.getWarehouse()
    this.initAfterSaleStatisticsList()
    this.initAfterSaleList()
    this.initGetProjectList()
    this.getLogisticsList()
  },

  methods: {
    toUrl(v) {
      this.$router.push({
        path: v,
      });
    },

    //获取仓库数据
    async getWarehouse() {
      let res = await expenses.getWarehouseData()
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
          this.warehouseId = arr.length > 0 ? arr[0].id : '';
        }
    },

    initAfterSaleList() {
      let warehouseId = this.warehouseId
      let date = this.date
      let data = {
        warehouseId,
        date
      }
      AfterSale.getAfterSaleList(data).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.projectId
            obj.name = i.projectName
            obj.createTime = i.finalOrderTime
            obj.finishOrderNums = i.receiveOutboundOrderNum
            obj.collectOrderNum = i.collectOrderInfo
            obj.yield = i.collectRateInfo
            obj.oneDaysWithin = i.collectOrderInfoOfOneDay
            obj.twoDaysWithin = i.collectOrderInfoOfBetweenOneAndTwoDay
            obj.twoDaysAway = i.collectOrderInfoOfMoreThanTwoDay
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    /* 仓库总计 */
    initAfterSaleStatisticsList() {
      let date = this.date
      let warehouseId = this.warehouseId
      let data = {
        date,
        warehouseId
      }
      AfterSale.getAfterSaleStatisticsList(data).then(res => {
        if (res.success) {
          let { collectOrderNum, finishOrderNum, notCollectOrderNum, lessThan24HoursNum,
          between24And48HoursNum, moreThan48HoursNum, lessThan24HoursExpressCollectNum,
          between24And48HoursExpressCollectNum, moreThan48HoursExpressCollectNum } = res.result
          this.statisticsList = [
            {isFlag: 0, title: '揽收订单数', content: collectOrderNum, img: require('../../../../../assets/images/shipment-data/total-order-num.png')},
            {isFlag: 0, title: '完成订单数', content: finishOrderNum, img: require('../../../../../assets/images/shipment-data/finish-order-num.png')},
            {isFlag: 0, title: '未揽收订单数', content: notCollectOrderNum, img: require('../../../../../assets/images/shipment-data/incomplete-order-num.png')},
            {list: lessThan24HoursExpressCollectNum, isFlag: 1, title: '24小时内揽收', content: lessThan24HoursNum, img: require('../../../../../assets/images/production-data/24hours.png')},
            {list: between24And48HoursExpressCollectNum, isFlag: 1, title: '24-48小时内揽收', content: between24And48HoursNum, img: require('../../../../../assets/images/production-data/36hours.png')},
            {list: moreThan48HoursExpressCollectNum ,isFlag: 1, title: '48小时以上揽收', content: moreThan48HoursNum, img: require('../../../../../assets/images/production-data/48hours.png')},
          ]
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    /* 获取项目名称 */
    initGetProjectList() {
      personnelPay.getProjectList().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.projectList = arr;
        }
      });
    },

    /* 未揽收订单数 */
    async initUncollectedOrderNumsList() {
      let date = this.date
      let warehouseId = this.warehouseId
      let currentPage = this.currentPage
      let projectId = this.projectName
      let expressType = this.expressId
      let data = {
        date,
        warehouseId,
        currentPage,
        projectId,
        expressType
      }
      let res = await AfterSale.getUncollectedOrderNumsList(data)
      if (res.success) {
        let arr = [];
        this.total = res.result.totalNum
        res.result.items.map((i) => {
          let obj = {};
          obj.id = i.id;
          obj.projectName = i.projectName;
          obj.orderCode = i.systemOrderNo;
          obj.expenseCode = i.expressNo;
          obj.expressTypeName = i.expressTypeName;
          arr.push(obj);
        });
        this.uncollectedOrderNumsTableList = arr;
      }
    },

    /* 获取快递类型 */
    getLogisticsList() {
      logistics.getExpressData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.logisticsList = arr;
        }
      });
    },

    /* 揽收单量 */
    async initCollectedOrderNumsList() {
      let date = this.date
      let warehouseId = this.warehouseId
      let currentPage = this.collectedTotalCurrentPage
      let projectId = this.collectedProjectId
      let carrierId = this.expressType
      let collectPaymentDifferenceType = this.type
      let data = {
        date,
        warehouseId,
        currentPage,
        carrierId,
        projectId,
        collectPaymentDifferenceType
      }
      let res = await AfterSale.getcollectedOrderNumsList(data)
      if (res.success) {
        let arr = [];
        this.collectedTotal = res.result.totalNum
        res.result.items.map((i) => {
          let obj = {};
          obj.orderCode = i.systemOrderNo;
          obj.expenseCode = i.expressNo;
          obj.paymentTime = i.paymentTime == 0?'':formaTimeToMinute(i.paymentTime);
          obj.orderTakingTime = i.warehouseOrderTime == 0?'':formaTimeToMinute(i.warehouseOrderTime);
          obj.finishTime = i.outboundTime == 0?'':formaTimeToMinute(i.outboundTime);
          obj.collectedTime = i.collectTime == 0?'':formaTimeToMinute(i.collectTime);
          arr.push(obj);
        });
        this.collectedOrderNumsTableList = arr;
      }
    },
    
    clearData() {
      this.date = "";
      this.warehouseId = "";
    },

    searchData() {
      if (!this.warehouseId) return this.$message.error('请选择仓库')
      if (!this.date) return this.$message.error('请选择日期')
      this.initAfterSaleStatisticsList()
      this.initAfterSaleList()
    },

    async openUncollectedOrderNums() {
      await this.initUncollectedOrderNumsList()
      this.dialog = true
    },

    closeDialog() {
      this.currentPage = 1;
      this.projectName = ''
      this.expressId = ''
      this.dialog = false
    },
    
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initUncollectedOrderNumsList();
    },

    searchUncollectedOrderNumsData() {
      this.currentPage = 1;
      this.initUncollectedOrderNumsList()
    },

    async openTwoDaysWithinCollectedOrderNums(id) {
      this.type = 2
      this.collectedProjectId = id
      this.dialogTitle = '24H-48H揽收单量'
      await this.initCollectedOrderNumsList()
      this.collectedOrderNumsDialog = true
    },

    async openTwoDaysAwayCollectedOrderNums(id) {
      this.type = 3
      this.collectedProjectId = id
      this.dialogTitle = '48H以上揽收单量'
      await this.initCollectedOrderNumsList()
      this.collectedOrderNumsDialog = true
    },

    collectedQueryChange(data) {
      this.collectedTotalCurrentPage = data.currentPage;
      this.initCollectedOrderNumsList();
    },

    closeCollectedOrderDialog() {
      this.collectedTotalCurrentPage = 1;
      this.type = 1
      this.dialogTitle = '24H-48H揽收单量'
      this.expressType = ''
      this.collectedOrderNumsDialog = false
    },

    searchCollectedOrderNumsData() {
      this.collectedTotalCurrentPage = 1;
      this.initCollectedOrderNumsList()
    },

    downLoadExcel() {
      let date = this.date
      let warehouseId = this.warehouseId
      let currentPage = this.currentPage
      let projectId = this.projectName
      let expressType = this.expressId
      let data = {
        date,
        warehouseId,
        currentPage,
        projectId,
        expressType
      }
      AfterSale.getExportUncollectedOrderNumsExcel(data).then((res) => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    }
  }
}
</script>

<style lang='scss'>
.after-sale {
  flex: 1;
  .switch-menu {
    height: 56px;
    border-radius: 8px;
    background: #fff;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    padding: 0px 20px;
    .menu-name {
      height: 56px;
      line-height: 56px;
      margin-right: 32px;
      .el-radio-button__inner {
        font-size: 16px;
        font-weight: bold;
        border: none;
        color: #666666;
        background: transparent;
        padding: 0;
      }
      .is-active {
        border-bottom: 2px solid #2E68EA;
        .el-radio-button__inner {
          color: #2E68EA;
        }
      }
    }
  }
  
  .search-container {
    background: #fff;
    border-radius: 4px;
    padding:0px 20px 16px 20px;
    margin-bottom: 16px;
    .statistics {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      border-bottom: 1px solid #eee;
      margin-bottom: 16px;
      .border-top {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          left: 50%;
          transform: translate(-50%);
          top: 0px;
          height: 1px;
          width: 90%;
          background-color: #eee;
        }
      }
      .border-right {
        position: relative;
        &::before {
          content: '';
          position: absolute;
          left: 0%;
          top: 50%;
          transform: translateY(-50%);
          height: 66px;
          width: 1px;
          background-color: #eee;
        }
      }
      .statistics-info {
        width: 100%;
      }
      .item-statistics {
        width: 33.33%;
        height: 106px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding-left: 41px;
        .statistics-img {
          width: 56px;
          height: 56px;
          margin-right: 21px;
        }
        .sub-title {
          font-size: 14px;
          font-weight: 400;
          color: #999999;
        }
        .sub-content {
          margin-top: 14px;
          font-size: 24px;
          font-weight: 400;
          color: #333333;
        }
        .express-container {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          margin-top: 14px;
          height: 24px;
          .express-content {
            width: 50%;
          }
        }
      }
      .item-statistics:nth-child(1),
      .item-statistics:nth-child(4) {
        padding-left: 0px;
      }
      .border-right:nth-child(1),
      .border-right:nth-child(4) {
        &::before {
          display: none;
          width: 0;
          height: 0;
        }
      }
      .border-top:nth-child(4) {
        &::after {
          left: 0%;
          width: 95.2%;
          transform: translate(0%);
        }
      }
      .border-top:nth-child(6) {
        &::after {
          left: 34px;
          width: 93.7%;
          transform: translate(0%);
        }
      }
    }
  }
  .search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-select {
      margin-right: 16px;
    }
    .el-input {
      width: 200px;
    }
    .btn-blue {
      margin-left: 16px;
    }
    .marginRight {
      margin-right: 16px;
    }
  }
  
  .look-img {
    width: 14px;
    height: 14px;
    cursor: pointer;
    margin-left: 10px;
    vertical-align: top;
  }

  .production-list-container {
    background: #fff;
    margin-top: 20px;
    border-radius: 8px;
    padding: 20px;
    .columns {
      height: 32px;
      background: #F5F7FA;
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      font-size: 14px;
      .long {
        width: 360px;
        display: flex;
        justify-content: center;
      }
      .short {
        flex: 1;
        display: flex;
        justify-content: center;
      }
    }
    .order-list {
      .order {
        font-size: 12px;
        color: #606266;
        margin-bottom: 20px;
        .time-ordernum {
          height: 32px;
          padding-left: 10px;
          background: #F5F7FA;
          border-radius: 2px 2px 0px 0px;
          border: 1px solid #EBEEF5;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          box-sizing: border-box;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          .time {
            margin-right: 52px;
          }
        }
        .production-content {
          display: flex;
          flex-direction: row;
          border: 1px solid #EBEEF5;
          border-top: none;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          .long {
            width: 360px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-right: 1px solid #EBEEF5;
          }
          .short {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 12px 4px;
            box-sizing: border-box;
            border-right: 1px solid #EBEEF5;
            &:last-child {
              border-right: none;
            }
            .details-nums {
              margin-bottom: 8px;
            }
            .details-expenses {
              color: #999999;
              margin-bottom: 6px;
              &:last-child {
                margin-bottom: 0px;
              }
            }
          }
        }
      }
    }
    .tip {
      border: 1px solid #e4e4e4;
      height: 80px;
      text-align: center;
      line-height: 80px;
      font-size: 12px;
      color: #909399;
    }
  }
  
  .el-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 16px;
    }
    .el-dialog__body {
      .search-dialog {
        margin-bottom: 16px;
        display: flex;
        justify-content: space-between;
        .el-select {
          margin-right: 20px;
        }
      }
      .table {
        .el-table {
          .el-table__body-wrapper {
            height: 297px;
            overflow-y: auto;
          }
        }
        .pagination {
          display: flex;
          justify-content: flex-end;
        }
      }
    }
    .el-dialog__footer {
      padding: 0px;
      .dialog-footer {
        border-top: 1px solid #eee;
        padding-top: 16px;
        padding-bottom: 16px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
